import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';


@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(private httpClient: HttpClient) {
  }

  signIn(data: any) {
    return this.httpClient.post(
      environment.baseUrl + `registration/ssp/login/v2`,
      data
    )
  }

  verifyOtp(data: any, bId : any) {
    return this.httpClient.put(
      environment.baseUrl + `registration/ssp/verifyOtp?businessId=${bId}`,
      data
    )
  }

  endUserDetails(userId: any, referralUniqueId: any) {
    const url = environment.baseUrl.split('/passbook')[0]
    return this.httpClient.post(
      url + `api/end-user/referralDetails?userId=${userId}&referralUniqueId=${referralUniqueId}`, {}
    )
  }
  resendOtp(data: any) {
    return this.httpClient.post(
      environment.baseUrl + `registration/ssp/resend/otp`,
      data
    )
  }

  refreshToken(){
    return this.httpClient.get(
      environment.baseUrl+`registration/token`
    )
  }


  updateStaff(data:any){
    return this.httpClient.put(
      environment.baseUrl + `user/user/staff`,
      data
    )
  }



}
